import React from "react"
export function Wallet(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M15.325 3.185c.006.05.008.099.008.148v1.332L4 4.666c-.327 0-.6.236-.656.547l-.01.12c0 .327.235.6.546.656l.12.01h12.667C17.403 6 18 6.598 18 7.334v9.333c0 .737-.597 1.334-1.333 1.334H3.333A1.333 1.333 0 012 16.666V7.333l.004-.072-.003-.063L2 4.526c0-.68.51-1.25 1.185-1.326l10.667-1.192a1.333 1.333 0 011.473 1.177zm.008 8.148a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667z"
        fill="currentColor"
        id="prefix__wallet"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
